module.exports = new __parcel__URL__("send.db914cab.svg").toString();